module.exports = __webpack_public_path__ + "img/logo.9d8f60c2.png";